// A documents item dnd-kit can pick up: the drag wiring, plus the style that
// moves it with the pointer and fades it while it is dragged.

import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

export function useDragItem(id: string, type: 'document' | 'folder', disabled: boolean) {
  const { setNodeRef, attributes, listeners, transform, isDragging } = useDraggable({ id, data: { type }, disabled });

  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.4 : 1,
  };

  return { setNodeRef, attributes, listeners, isDragging, style };
}
